import { render, staticRenderFns } from "./FooterBase.vue?vue&type=template&id=14bdbc06&scoped=true"
import script from "./FooterBase.vue?vue&type=script&lang=js"
export * from "./FooterBase.vue?vue&type=script&lang=js"
import style0 from "./FooterBase.vue?vue&type=style&index=0&id=14bdbc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bdbc06",
  null
  
)

export default component.exports